<template>
  <div class="p-commonLoader">
    <svg version="1.1" id="wave" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 80 16" style="enable-background:new 0 0 80 16" xml:space="preserve">
    <path class="wave" d="M79,8.4c-3.9-4.2-11.6-7-20.3-7c-7,0-13.2,2.5-19.2,6.5c-5.9,4-12.8,6.1-19.9,6c-7.6,0-14.3-2-18.5-5.3"/>
    </svg>
  </div>
</template>

<script>
  /**
   * Share Partial
   */

  export default {
    name: 'common-loader',
    computed: {
    },
    mounted() {
    }
  }
</script>


// WEBPACK FOOTER //
// src/partial/common-loader.vue